{
  "AllSetTitle": "Tout est prêt",
  "AllSetSubtitle": "Aucun questionnaire n'est disponible pour le moment.",
  "Back": "Retour",
  "Cancel": "Annuler",
  "CompletedAtDate": "Terminé le {{at}}",
  "ConsentDeclinedSubtitle": "Vous avez refusé de participer. L'équipe de l'étude reste disponible si vous avez des questions.",
  "ConsentDeclinedTitle": "Consentement refusé",
  "DevDataExport": "[DEV] Data Export",
  "DevDebug": "[DEV] Debug",
  "DevDemo": "[DEV] Demo",
  "EnrollmentClosedSubtitle": "Le délai pour terminer cette étape est écoulé. L'équipe de l'étude reste disponible si vous avez des questions.",
  "EnrollmentClosedTitle": "Inscription clôturée",
  "EnrollmentCompleteSubtitle": "Votre consentement est signé. Il n'y a rien d'autre à faire ici pour le moment — l'équipe de l'étude vous contactera.",
  "EnrollmentCompleteSubtitlePrescreenOnly": "Il n'y a rien d'autre à faire ici pour le moment — l'équipe de l'étude vous contactera.",
  "EnrollmentCompleteTitle": "Tout est prêt — consentement signé",
  "EnrollmentCompleteTitlePrescreenOnly": "Tout est prêt",
  "EnrollmentEyebrowConsent": "Étape 2 sur 2 · Consentement éclairé",
  "EnrollmentEyebrowConsentOnly": "Consentement éclairé",
  "EnrollmentEyebrowPrescreen": "Étape 1 sur 2 · Présélection",
  "EnrollmentEyebrowPrescreenOnly": "Présélection",
  "EnrollmentFooter": "La participation est volontaire. Vous pouvez arrêter à tout moment.",
  "EnrollmentHeroBodyConsent": "Veuillez lire attentivement le formulaire de consentement. Vous pouvez poser toutes vos questions à l'équipe de l'étude avant de signer, et vous pouvez vous retirer à tout moment.",
  "EnrollmentHeroBodyPrescreen": "Répondez à quelques questions courtes sur votre santé. Cela prend environ 5 minutes et vos réponses restent confidentielles.",
  "EnrollmentHeroCtaConsent": "Lire et signer le consentement",
  "EnrollmentHeroCtaConsentResume": "Reprendre la lecture du consentement",
  "EnrollmentHeroCtaPrescreen": "Commencer la présélection",
  "EnrollmentHeroCtaPrescreenResume": "Reprendre la présélection",
  "EnrollmentHeroTitleConsent": "Vous êtes éligible — consultez votre consentement",
  "EnrollmentHeroTitleConsentOnly": "Consultez votre consentement",
  "EnrollmentHeroTitlePrescreen": "Voyons si cette étude vous convient",
  "EnrollmentSectionLabel": "Votre inscription",
  "EnrollmentStepConsentBlurb": "Consultez et signez votre formulaire de consentement",
  "EnrollmentStepConsentName": "Consentement éclairé",
  "EnrollmentStepDone": "Terminé",
  "EnrollmentStepNext": "Suivant",
  "EnrollmentStepPrescreeningBlurb": "Quelques questions pour vérifier que cette étude vous convient",
  "EnrollmentStepPrescreeningName": "Présélection",
  "ErrorUpdatingUser": "Erreur de mise à jour de l'utilisateur",
  "ExternalIdMissingSubtitle": "Ouvrez à nouveau l'étude depuis l'endroit où vous avez fait votre inscription.",
  "ExternalIdMissingTitle": "Impossible d'ouvrir cette étude",
  "Failure": "Échec",
  "Done": "Terminé",
  "Finish": "Terminer",
  "FormProgress": "Progression du formulaire : {{progress}}%",
  "Home": "Accueil",
  "HomeSeeAllTasks": "Voir toutes les tâches à venir dans Programme",
  "HomeTasksToday": "Tâches pour aujourd'hui, {{date}}",
  "Language": "Langue",
  "Leave": "Quitter",
  "Loading": "Chargement",
  "loadingScreenDoNotCloseMessage": "Cela peut prendre un moment. Veuillez ne pas fermer cette page.",
  "LogOut": "Déconnexion",
  "LogoutConfirmationBody": "Êtes-vous sûr de vouloir vous déconnecter ?",
  "LogoutConfirmationHeader": "Déconnexion",
  "More": "Plus",
  "MyStudies": "Mes Études",
  "Next": "Suivant",
  "NoSchedule": "Aucun programme attribué",
  "NoScheduleDescription": "Vos tâches apparaîtront ici dès qu’un programme vous aura été attribué.",
  "NoScheduleForMonth": "Aucune tâche ce mois-ci",
  "NoScheduleForMonthDescription": "Vous n’avez actuellement aucune tâche prévue pour ce mois-ci. Vous pouvez consulter les mois suivants pour vos prochaines tâches.",
  "NoScheduleForWeek": "Aucune tâche cette semaine",
  "NoScheduleForWeekDescription": "Vous n’avez actuellement aucune tâche prévue pour cette semaine. Vous pouvez consulter les semaines suivantes pour vos prochaines tâches.",
  "NotAnswered": "Non répondu",
  "NoTasksForToday": "Tu n’as pas de tâches pour aujourd’hui.",
  "NotFoundSubtitle": "La page que vous recherchez n’existe pas.",
  "NotImplementedYet": "Bientôt disponible...",
  "OfflineWarning": "Vous êtes hors ligne. Veuillez vérifier votre connexion Internet.",
  "Previous": "Précédent",
  "Processing": "Traitement",
  "QuestionnaireCompleteFailureMessage": "Échec de la complétion du questionnaire. Veuillez réessayer.",
  "questionnaireInitializationLoadingTitle": "Préparation de votre questionnaire",
  "QuestionnaireRedirecting": "Redirection...",
  "QuestionnaireLeaveWarningMessage": "Votre progression est enregistrée, mais l'évaluation n'est pas officiellement soumise. Si vous partez maintenant, vous devrez reprendre plus tard pour la terminer.",
  "QuestionnaireLeaveWarningTitle": "Pas encore terminé ?",
  "PostQuestionnaireLeaveWarningMessage": "Votre questionnaire a été soumis. Vous pouvez consulter les informations restantes maintenant, ou y revenir plus tard.",
  "PostQuestionnaireLeaveWarningTitle": "Presque terminé !",
  "preScreeningBadge": "dépistage",
  "QuestionnaireNotAvailableNow": "Ce questionnaire n'est pas disponible maintenant",
  "QuestionnaireNotAvailableSubtitle": "Votre questionnaire est terminé ou n'est pas accessible pour le moment.",
  "PreScreeningCompleteTitle": "Présélection terminée",
  "PreScreeningCompleteSubtitle": "Merci — il n'y a rien d'autre à faire ici pour le moment.",
  "QuestionnaireNotAvailableTitle": "Rien à voir ici",
  "questionnaireSubmissionLoadingTitle": "Enregistrement de vos réponses",
  "QuestionnaireSummaryDescription": "Merci d’avoir rempli ce questionnaire. Veuillez vérifier vos réponses et les soumettre lorsque vous avez terminé.",
  "QuestionnaireUpdateFailureMessage": "Échec de la mise à jour du questionnaire. Veuillez réessayer.",
  "QuestionnaireValidationErrorOnPreviousPage": "Certaines réponses sur une page précédente ne sont plus valides. Veuillez les corriger avant de continuer.",
  "ProtocolEditor": "Protocol Editor",
  "ProtocolList": "Protocols",
  "Brands": "Brands",
  "Save": "Sauvegarder",
  "Schedule": "Programme",
  "ScheduleDayTasks_one": "{{count}} tâche",
  "ScheduleDayTasks_other": "{{count}} tâches",
  "SessionExpiryBody_one": "Pour votre sécurité, vous serez déconnecté dans {{count}} seconde.",
  "SessionExpiryBody_other": "Pour votre sécurité, vous serez déconnecté dans {{count}} secondes.",
  "SessionExpiryStay": "Rester connecté",
  "SessionExpiryTitle": "Vous êtes toujours là ?",
  "ShellAccountButtonLabel": "Compte",
  "ShellAccountDevSectionLabel": "Développeur et administration",
  "ShellDarkModeLabel": "Mode sombre",
  "ShellNavLabel": "Navigation principale",
  "SignedOutBody": "Pour votre sécurité, vous êtes déconnecté après {{minutes}} minutes d’inactivité. Les réponses déjà enregistrées sont conservées.",
  "SignedOutSignInAgain": "Se reconnecter",
  "SignedOutTitle": "Vous avez été déconnecté",
  "SkipToContent": "Aller au contenu",
  "Stay": "Rester",
  "StudyInfo": "Infos d'étude",
  "studyParticipationBadge": "participation",
  "Success": "Succès",
  "Surveys": "Questionnaires",
  "SystemInfo": "Info système",
  "TaskRowAvailableNow": "Disponible maintenant",
  "TaskRowDue": "Échéance {{time}}",
  "TaskRowOpenUntil": "Ouvert jusqu'à {{time}}",
  "TaskRowOpens": "Ouvre {{time}}",
  "TaskRowOpensUntil": "Ouvre\u00a0{{opens}}, jusqu'à\u00a0{{until}}",
  "Today": "Aujourd'hui",
  "TranslationNotInManifest": "Le fichier de traduction n'est pas spécifié dans le manifeste ({{assetId}}, {{language}})",
  "UserUpdated": "Utilisateur mis à jour",
  "authError": {
    "connection": {
      "title": "Erreur de connexion",
      "message": "Impossible de se connecter au service d'authentification. Veuillez vérifier votre connexion Internet et réessayer."
    },
    "authService": {
      "title": "Échec de l'authentification",
      "message": "L'authentification a échoué. Veuillez réessayer."
    },
    "unknown": {
      "title": "Erreur inattendue",
      "message": "Une erreur inattendue s'est produite lors de l'authentification. Veuillez réessayer."
    },
    "tryAgain": "Réessayer"
  }
}
